<span class="countdown-timer-widget">{{displayTime()}}</span>